import { useEffect, useState } from 'react'
import { fetchWithAuth, isAuthenticated, onAuthChange } from '../lib/auth.js'

export default function useMe() {
  const [me, setMe] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      if (!isAuthenticated()) {
        setMe(null)
        return
      }
      setLoading(true)
      try {
        const res = await fetchWithAuth('/api/v1/me', { headers: { Accept: 'application/json' } })
        if (cancelled) return
        if (res.ok) setMe(await res.json())
        else setMe(null)
      } catch {
        if (!cancelled) setMe(null)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    const off = onAuthChange(load)
    return () => { cancelled = true; off() }
  }, [])

  return { me, loading }
}
